import { DialogsStore } from 'shared/model/dialogs.store';

DialogsStore.setComponentLoaders({
  addAllergies: () => import('dialogs/add.allergies.dialog'),
  addInsurance: () => import('dialogs/add.insurance.dialog'),
  addDiagnosis: () => import('dialogs/add.diagnosis.dialog'),
  vendorOrderSetMedicationEdit: () => import('dialogs/vendor.order.set.medication.edit.dialog'),
  vendorCompoundSetup: () => import('dialogs/vendor.compound.setup.modal'),
  vendorCompoundEditName: () => import('dialogs/vendor.compound.edit.name.modal'),
  vendorCompoundEdit: () => import('dialogs/vendor.compound.edit.dialog'),
  setupEpa: () => import('dialogs/setup.epa.dialog'),
  eulaApproval: () => import('dialogs/eula.approval.dialog'),
  legalDocumentEdit: () => import('dialogs/legal.document.edit.dialog'),
  setupMedCart: () => import('dialogs/setup.medcart.dialog'),
  orderSetInsuranceEdit: () => import('features/order.set/order.set.insurance.edit'),
  addVendorOrganization: () => import('features/vendor/add.vendor.organization.modal'),
  allergySearch: () => import('features/allergy/allergy.search.modal'),
  editMedication: () => import('features/prescription/edit.medication'),
  prescriptionDetailRefillRx: () => import('dialogs/prescription.detail.refill.rx'),
  prescriptionDetailChangeRx: () => import('dialogs/prescription.detail.change.rx'),
  petPatientClientSelect: () => import('dialogs/pet.patient.client.select.modal'),
  searchPatient: () => import('features/patient/search.patient.modal'),
  messageXmlDetail: () => import('dialogs/message.xml.detail.dialog'),
  requestPharmacy: () => import('dialogs/request.pharmacy'),
  deletedPrescriptionsList: () => import('features/drug/deleted.prescriptions.list.modal'),
  messageDrugHistory: () => import('features/message/message.drug.history.modal'),
  advancedSearchPatients: () => import('features/patient/advanced.search.patients'),
  mergePatients: () => import('features/patient/merge.patient.modal'),
  accessRequests: () => import('features/access.request/access.requests.modal'),
  allergyEdit: () => import('features/allergy/allergy.edit.modal'),
  auditLog: () => import('features/auditlog/audit.log.modal'),
  addBillingAccount: () => import('features/billing.account/add.billing.account.modal'),
  billingEngineLogs: () => import('features/billing/billing.engine.logs.modal'),
  billingInvoiceDetail: () => import('features/billing/billing.invoice.detail.modal'),
  billingInvoicePreview: () => import('features/billing/billing.invoice.preview.modal'),
  billingLicenseCostPreview: () => import('dialogs/billing.license.cost.preview.modal'),
  billingEmailProgress: () => import('features/billing/billing.report.email.progress.modal'),
  billingPaymentProcessorSelector: () => import('features/billing/billing.payment.processor.selector.modal'),
  billingScheduleEdit: () => import('features/billing/billing.schedule.edit.modal'),
  billingScheduleSelect: () => import('features/billing/billing.schedule.select.modal'),
  businessUnitAdd: () => import('features/business.unit/business.unit.add.modal'),
  businessUnitAdminAdd: () => import('features/business.unit/business.unit.admin.add.modal'),
  commentAdd: () => import('features/comments/comment.add.modal'),
  comments: () => import('features/comments/comments.modal'),
  confirm: () => import('features/common/confirm.modal'),
  print: () => import('features/common/print.modal'),
  prompt: () => import('features/common/prompt.modal'),
  compoundAddDrug: () => import('features/compound/compound.add.drug.modal'),
  compoundEdit: () => import('features/compound/compound.edit.modal'),
  compound: () => import('features/compound/compound.modal/ui/compound.modal/compound.modal'),
  prescriptionCompound: () => import('features/compound/compound.modal/ui/prescription.compound.modal/prescription.compound.modal'),
  compoundSelect: () => import('features/compound/compound.select.modal'),
  compoundSetup: () => import('features/compound/compound.setup.modal'),
  dashboard: () => import('features/dashboard/dashboard.modal'),
  addDawUserModal: () => import('features/daw/ui/add.daw.user.modal'),
  dawRoleModal: () => import('features/daw/ui/daw.role.modal'),
  diagnosisEdit: () => import('features/diagnosis/diagnosis.edit.modal'),
  diagnosisMap: () => import('features/diagnosis/diagnosis.map.modal'),
  diagnosisSearch: () => import('features/diagnosis/diagnosis.search.modal'),
  addPrescriptionComment: () => import('features/drug/add.comment.modal'),
  changeExpirationDate: () => import('features/drug/change.expiration.date.modal'),
  commentsList: () => import('features/drug/comments.list.modal'),
  diagnosisList: () => import('features/drug/diagnosis.list.modal'),
  doseInfo: () => import('features/drug/dose.info.modal'),
  drugCustomFormatEdit: () => import('features/drug/drug.custom.format.edit.modal'),
  drugDetail: () => import('features/drug/drug.detail.off.canvas'),
  drugInformation: () => import('features/drug/drug.information.modal'),
  drugListSetupFavorite: () => import('features/drug/drug.list.setup.favorite.modal'),
  epaMessageCancel: () => import('dialogs/epa.message.cancel.modal'),
  formatDosage: () => import('features/drug/format.dosage.modal'),
  interactionsInfo: () => import('features/drug/interactions.info.modal'),
  lastPrescriptionsList: () => import('dialogs/last.prescriptions.list.modal'),
  medicationTimeline: () => import('features/drug/medication.timeline.modal'),
  currentMedication: () => import('features/drug/current.medication.modal'),
  encounter: () => import('dialogs/encounter.modal'),
  epcsRequests: () => import('features/epcs/epcs.requests.modal'),
  copyFavorite: () => import('features/favorite/favorite.copy.modal'),
  copyFavoriteOfUser: () => import('features/favorite/favorite.copy.of.user.modal'),
  eligibilityUpload: () => import('features/invite/eligibility.upload.modal'),
  invitationEdit: () => import('features/invite/invitation.edit.modal'),
  invitationOrganizationAdd: () => import('features/invite/invitation.organization.add.modal'),
  invitationOrganization: () => import('features/invite/invitation.organization.modal'),
  invitationOrganizationPracticeEdit: () => import('features/invite/invitation.organization.practice.edit.modal'),
  invitationOrganizationUserEdit: () => import('features/invite/invitation.organization.user.edit.modal'),
  invitationSubscriptionAdd: () => import('features/invite/invitation.subscription.add.modal'),
  inviteLink: () => import('features/invite/invite.link.modal'),
  invitePracticeExists: () => import('features/invite/invite.practice.exists.modal'),
  inviteUser: () => import('dialogs/invite/invite.user.modal'),
  prescriptionVeterinarianDetail: () => import('dialogs/prescription.veterinarian.detail'),
  medline: () => import('features/medline'),
  rxMessage: () => import('features/message/rx.message.modal'),
  soapNoteEdit: () => import('features/notes/soap.note.edit.modal'),
  notifyEdit: () => import('features/notify/notify.edit.modal'),
  orderSetAddEducation: () => import('features/order.set/add.education.modal'),
  orderSetAddMedication: () => import('features/order.set/add.medication.modal'),
  order: () => import('features/order.set/order.modal/ui/order.modal'),
  orderSetEdit: () => import('features/order.set/order.set.edit.modal'),
  orderSetExecute: () => import('features/order.set/order.set.execute.modal'),
  orderSetSelect: () => import('features/order.set/order.set.select.modal'),
  orderSetSetup: () => import('features/order.set/order.set.setup.modal'),
  existingOrganizationAdd: () => import('features/organization/existing.organization.add.modal'),
  organizationChangeStatusExtended: () => import('features/organization/organization.change.status.extended.modal'),
  organizationChangeStatus: () => import('features/organization/organization.change.status.modal'),
  organizationEdit: () => import('features/organization/organization.edit.modal'),
  idme: () => import('features/otp/idme.modal'),
  otp: () => import('features/otp/otp.modal'),
  addPatient: () => import('features/patient/add.patient.modal'),
  duplicatePatient: () => import('features/patient/dublicate.patient.modal/ui/dublicate.patient.modal'),
  patientDeath: () => import('features/patient/patient.death.modal'),
  petPatientEdit: () => import('dialogs/pet.patient.edit.modal'),
  patientClientEdit: () => import('dialogs/patient.client.edit.modal'),
  eligibilityHistory: () => import('features/patient/eligibility.history.modal'),
  patientChartSummary: () => import('features/patient/patient.chart.summary.modal'),
  customPharmacies: () => import('features/pharmacy/custom.pharmacies'),
  pharmacySearch: () => import('features/pharmacy/pharmacy.search.modal'),
  pharmacySearchForm: () => import('dialogs/pharmacy.search.form.modal'),
  pharmacy: () => import('features/pharmacy/pharmacy.modal'),
  practiceSearch: () => import('features/practice/practice.search.modal'),
  practiceSelect: () => import('features/practice/practice.select'),
  practiceUpdate: () => import('features/practice/practice.update.modal'),
  practiceUserList: () => import('features/practice/practice.user.list.modal'),
  cancelPrescriptionReason: () => import('features/prescription/cancel.prescription.reason.modal'),
  validationErrors: () => import('features/common/validation.errors.modal'),
  setCustomDayInternal: () => import('features/prescription/set.custom.day.internal.modal'),
  deletePrescriptionReason: () => import('features/prescription/delete.prescription.reason.modal'),
  drugCheck: () => import('features/prescription/drug.check.modal'),
  drugFormatConfirm: () => import('features/prescription/drug.format.confirm.modal'),
  prescriptionConfirm: () => import('features/prescription/prescription.confirm.modal'),
  prescriptionDetail: () => import('features/prescription/prescription.detail/ui/prescription.detail'),
  prescriptionEPADetail: () => import('dialogs/prescription.epa.detail/ui/prescription.epa.detail'),
  prescriptionEditStatus: () => import('features/prescription/prescription.edit.status.modal'),
  prescription: () => import('features/prescription/prescription.modal'),
  prescriptionQueue: () => import('features/prescription/prescription.queue.modal'),
  prescriptionStatuses: () => import('features/prescription/prescription.statuses.modal'),
  prescriptionReassignProvider: () => import('dialogs/prescription.reassign.provider.modal'),
  messageReassignProvider: () => import('dialogs/message.reassign.provider.modal'),
  newRxRequestReview: () => import('dialogs/new.rx.request.review.dialog'),
  newRxRequestDeclineConfirm: () => import('dialogs/new.rx.request.decline.confirm.dialog'),
  electronicRegistration: () => import('features/register/electronic.registration.modal'),
  reportAuditLog: () => import('features/report/report.audit.log'),
  reportAutomatedMeasure: () => import('features/report/report.automated.measure'),
  reportDocument: () => import('features/report/report.document'),
  securityRolesAdd: () => import('features/restrictions/security.roles.add.modal'),
  securityRolesEdit: () => import('features/restrictions/security.roles.edit.modal'),
  securityRoles: () => import('features/restrictions/security.roles.modal'),
  advancedSearch: () => import('features/search/advanced.search.modal'),
  settingsEpcs: () => import('features/settings/settings.epcs.modal'),
  settingsInvite: () => import('features/settings/settings.invite.modal'),
  userEdit: () => import('features/settings/ui/user.profile/information.modal/settings.user.profile.information.modal'),
  setupIdmeProof: () => import('features/setup/setup.idme.proof.modal'),
  userBillingSetup: () => import('features/setup/user.billing.setup.modal'),
  infoSign: () => import('features/sign/info.sign.modal'),
  sign: () => import('features/sign/sign.modal'),
  addApplications: () => import('features/user/add.applications.modal'),
  userDawApproval: () => import('features/user/user.daw.approval.modal'),
  userInactivate: () => import('features/user/user.inactivate.modal'),
  userPracticeLocation: () => import('features/user/user.practice.location.modal'),
  userPrescribeFor: () => import('features/user/user.prescribe.for.modal'),
  userPrescribeUsing: () => import('features/user/user.prescribe.using.modal'),
  userSearch: () => import('features/user/user.search.modal'),
  userSpi: () => import('features/user/user.spi.modal'),
  userUpload: () => import('features/user/user.upload.modal'),
  userUploadPreview: () => import('features/user/user.upload.preview.modal'),
  userVendors: () => import('features/user/user.vendors.list.modal'),
  vendorAdjustCredits: () => import('features/vendor/vendor.billing.adjust.credits.modal'),
  vendorBillingInvoiceDetail: () => import('features/vendor/vendor.billing.invoice.detail.modal'),
  vendorBillingUpdate: () => import('features/vendor/vendor.billing.update.modal'),
  vendorViewCredits: () => import('features/vendor/vendor.billing.view.credits.modal'),
  vendorAdministratorUpdate: () => import('features/vendor/vendor.contact.update.administrator.modal'),
  vendorContactUpdate: () => import('features/vendor/vendor.contact.update.contact.modal'),
  editVendorDocument: () => import('features/vendor/vendor.document.edit.modal'),
  searchVendorAdministrators: () => import('features/vendor/search.vendor.administrators.modal'),
  setRelatedVendors: () => import('features/vendor/set.related.vendors.modal'),
  vendorUpdate: () => import('features/vendor/vendor.update.modal'),
  vitalPrescription: () => import('features/vital/vital.prescription.modal'),
  vitalAdd: () => import('features/vital/vital.add.modal'),
  configureAppTemplateModal: () => import('features/dev.tools/ui/configure.app.template.modal'),
  reportsContactEdit: () => import('features/report/reports.contact.edit.modal'),
  addReleaseNoteModal: () => import('features/daw/ui/add.release.note.modal'),
  reportsView: () => import('features/report/report.view.modal'),
  massActions: () => import('shared/mass.actions.dialog'),
  addBroadcastModal: () => import('features/daw/ui/add.broadcast.modal'),
  viewBroadcastModal: () => import('features/notification.hub/broadcast/view.broadcast.modal'),
  nursingHomeEdit: () => import('features/practice/nursing.home.edit.dialog'),
  patientImportCreate: () => import('features/practice/practice.patient.import.create.dialog'),
  patientImportValidationEntity: () => import('features/practice/practice.patient.import.validation.entity.dialog'),
  userBusinessUnitAdminSetup: () => import('features/user/user.business.unit.admin.setup.modal'),
  manageTeams: () => import('features/admin.teams/manage.teams.dialog'),
  editTeam: () => import('features/admin.teams/edit.team.dialog'),
  pharmacyNickname: () => import('features/patient/pharmacy.nickname.modal'),
  addMFA: () => import('features/user/add.mfa.modal'),
  iframeViewer: () => import('features/common/iframe.viewer.modal'),
  addVendorInfoModal: () => import('features/daw/ui/add.vendor.info.modal'),
  invitationGotoEdit: () => import('features/invite/invitation.goto.modal'),
  addMobileReleaseModal: () => import('features/daw/ui/add.mobile.release.modal'),
  viewNotificationModal: () => import('features/notification.hub/notification/view.notification.modal'),
  vitalUpdate: () => import('dialogs/vital.update'),
  practiceMove: () => import('dialogs/practice.move.dialog'),
  practicesMove: () => import('dialogs/practices.move.dialog'),
  vendorPatientMove: () => import('features/practice/vendor.patient.move.dialog'),
  vendorPatientMerge: () => import('features/practice/vendor.patient.merge.dialog'),
  pharmacyRecords: () => import('features/patient/pharmacy.records.modal'),
  createNoPracticeOrganization: () => import('dialogs/create.no.practice.organization.modal'),
  vendorOrderSetEditName: () => import('dialogs/vendor.orderset.edit.name.modal'),
  vendorOrderSetSetup: () => import('dialogs/vendor.orderset.setup.modal'),
  statusCenterModal: () => import('features/notification.hub/status/status.center.modal'),
  quickEditMedication: () => import('dialogs/quick.edit.medication.modal'),
  bulkFormulary: () => import('dialogs/bulk.formulary.modal'),
  webhookStatus: () => import('dialogs/webhook.status.detail.modal'),
  releaseEventEditor: () => import('features/release.tracker/release.event.editor.modal'),
});
